import { useSelector } from 'react-redux';
import { Store } from 'components/common/types/Store.types';
import { getAllocatedFrames, getAllocatedImpressions } from 'store/dealManagement/selectors/availabilityAssets';
import { usePlannerMapAssets } from '../../PlannerMap/poiWorker/usePlannerMapAssets';
import { useDirectSalesPOI } from '../../PlannerMap/poiWorker/useDirectSalesPOI';
import { PlannerData } from '../../context/PlannerDataContext';
import { isDirectSalesLinePriced } from '../../hooks/utils/getIsDirectSalesLinePriced';
import { useMapAssetsTransform } from '../../hooks/useMapAssetsTransform';
import { useClusterAssetsData } from '../../hooks/useClusterAssetsData';

export const useDirectSalesPlannerData = (): PlannerData => {
  const assets = usePlannerMapAssets();
  const poiResult = useDirectSalesPOI(assets, { skipClustering: true });

  const { status } = useSelector((state: Store) => state.dealManagement.directSales.state);
  const allocatedFrames = useSelector(getAllocatedFrames);
  const allocatedImpressions = useSelector(getAllocatedImpressions);
  const isAllocated = isDirectSalesLinePriced(status) || !!(allocatedFrames && allocatedImpressions);

  const { mapAssetsToMapElements } = useMapAssetsTransform({ isAllocated });
  const { clusterAssetsData, handleViewportChange } = useClusterAssetsData({
    filteredAssets: poiResult.filteredAssets,
    mapAssetsToMapElements,
  });

  return {
    poiResult,
    clusterAssetsData,
    handleViewportChange,
  };
};
